/* Perfect Titanium — native PDP buy-box engine + live cart AJAX */
(function () {
  var root = document.querySelector('.pt-pdp');
  if (!root) return;
  var dataEl = document.getElementById('pt-pdp-data');
  if (!dataEl) return;
  var DATA = JSON.parse(dataEl.textContent);

  // ---- money ----
  var fmt = function (cents) {
    var v = (cents / 100);
    var s = v.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return (DATA.currencySymbol || '$') + s;
  };
  // short form for badges: drop trailing .00 (currency-dynamic)
  var fmtShort = function (cents) { return fmt(cents).replace(/\.00$/, ''); };

  // ---- variant lookup by thickness||size ----
  var byKey = {};
  DATA.variants.forEach(function (v) { byKey[v.thickness + '||' + v.size] = v; });
  var SIZE_ORDER = DATA.sizeOrder;            // ["29X20Cm","36X25Cm","46X30Cm"]
  var THICK_ORDER = DATA.thickOrder;          // ["Everyday 0.15cm","Pro 0.2cm"]
  var sizeMeta = DATA.sizeNames;              // {code:{name,dim}}

  function variantFor(thickness, sizeCode) { return byKey[thickness + '||' + sizeCode]; }
  function priceFor(thickness, sizeCode) { var v = variantFor(thickness, sizeCode); return v ? v.price : 0; }

  // ---- state ----
  var state = {
    thickness: THICK_ORDER[0],
    n: 1,
    disc: 0,
    sizes: [SIZE_ORDER[1], SIZE_ORDER[1], SIZE_ORDER[1]], // default Everyday size
    sharp: false,
    qty: 1
  };

  // Query across the whole document: the sticky ATC lives in a second .pt-pdp
  // wrapper (fixed-position), so root-scoped lookups would miss it. Only one
  // PDP renders per page, so ids/classes remain unambiguous.
  var $ = function (s) { return document.querySelector(s); };
  var $$ = function (s) { return document.querySelectorAll(s); };

  function boardPrice(i) { return priceFor(state.thickness, state.sizes[i]); }
  function subtotal() { var s = 0; for (var i = 0; i < state.n; i++) s += boardPrice(i); return s; }
  function boardsTotal() { return Math.round(subtotal() * (1 - state.disc)); }
  function grandTotal() { return (boardsTotal() + (state.sharp ? DATA.sharpener.price : 0)) * state.qty; }

  // ---- render per-board size pickers ----
  function renderBoards() {
    var wrap = $('#pt-boards');
    var html = '';
    var count = state.n;
    for (var b = 0; b < count; b++) {
      var label = count === 1 ? 'Size' : 'Board ' + (b + 1) + ' — choose size';
      html += '<div class="bsel"><div class="bl">' + label + '</div><div class="mini" data-board="' + b + '">';
      SIZE_ORDER.forEach(function (code, si) {
        var on = state.sizes[b] === code ? ' on' : '';
        html += '<div class="mseg' + on + '" data-board="' + b + '" data-size="' + code + '"><b>' +
          sizeMeta[code].name + '</b><span>' + sizeMeta[code].dim + '</span></div>';
      });
      html += '</div></div>';
    }
    wrap.innerHTML = html;
    wrap.querySelectorAll('.mseg').forEach(function (el) {
      el.onclick = function () {
        state.sizes[+el.dataset.board] = el.dataset.size;
        renderBoards(); update();
      };
    });
  }

  // ---- thickness ----
  $$('#pt-thick .seg').forEach(function (seg) {
    seg.onclick = function () {
      $$('#pt-thick .seg').forEach(function (s) { s.classList.remove('on'); });
      seg.classList.add('on');
      state.thickness = seg.dataset.thickness;
      var isPro = seg.dataset.thickness.indexOf('Pro') === 0;
      var gm = root.querySelector('.gmain'); if (gm) { if (isPro) gm.classList.add('pro-active'); else gm.classList.remove('pro-active'); }
      // swap caliper thumbs
      var showCal = isPro ? 'pro' : 'everyday';
      var hideCal = isPro ? 'everyday' : 'pro';
      var showThumb = root.querySelector('.thumb[data-caliper="' + showCal + '"]');
      var hideThumb = root.querySelector('.thumb[data-caliper="' + hideCal + '"]');
      if (showThumb) showThumb.style.display = '';
      if (hideThumb) { hideThumb.style.display = 'none'; hideThumb.classList.remove('active'); }
      // if active main image was the hidden caliper, swap to the visible one
      var mainImg = $('#pt-gmain');
      if (hideThumb && mainImg && mainImg.src === hideThumb.dataset.src) {
        if (showThumb) { mainImg.src = showThumb.dataset.src; showThumb.classList.add('active'); }
      }
      update();
    };
  });
  // default state: hide Pro caliper thumb (Everyday is default)
  var proCalThumb = root.querySelector('.thumb[data-caliper="pro"]');
  if (proCalThumb) proCalThumb.style.display = 'none';

  // ---- bundle ----
  $$('#pt-bundle .brow').forEach(function (row) {
    row.onclick = function () {
      $$('#pt-bundle .brow').forEach(function (r) { r.classList.remove('on'); });
      row.classList.add('on');
      state.n = +row.dataset.n; state.disc = +row.dataset.disc;
      renderBoards(); update();
    };
  });

  // ---- sharpener add-on ----
  var addon = $('#pt-addon');
  if (addon) addon.onclick = function () {
    state.sharp = !state.sharp; addon.classList.toggle('on', state.sharp); update();
  };

  // ---- qty ----
  var qplus = $('#pt-qplus'), qminus = $('#pt-qminus'), qinput = $('#pt-qty');
  if (qplus) qplus.onclick = function () { state.qty = Math.min(state.qty + 1, 9); qinput.value = state.qty; update(); };
  if (qminus) qminus.onclick = function () { state.qty = Math.max(state.qty - 1, 1); qinput.value = state.qty; update(); };

  // ---- gallery thumbs ----
  $$('#pt-thumbs .thumb').forEach(function (t) {
    t.onclick = function () {
      $$('#pt-thumbs .thumb').forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active');
      var img = $('#pt-gmain'); if (img) img.src = t.dataset.src;
    };
  });

  // ---- tabs ----
  $$('#pt-tabsnav button').forEach(function (b) {
    b.onclick = function () {
      $$('#pt-tabsnav button').forEach(function (x) { x.classList.remove('on'); });
      $$('.tabpane').forEach(function (p) { p.classList.remove('on'); });
      b.classList.add('on');
      var pane = root.querySelector('.tabpane[data-t="' + b.dataset.t + '"]');
      if (pane) pane.classList.add('on');
    };
  });

  // ---- faq ----
  $$('#pt-faq .qa button').forEach(function (btn) {
    btn.onclick = function () {
      var qa = btn.parentElement, ans = qa.querySelector('.ans');
      var open = qa.classList.contains('open');
      qa.classList.toggle('open', !open);
      ans.style.maxHeight = open ? null : ans.scrollHeight + 'px';
    };
  });

  // ---- UGC video play (one at a time) ----
  $$('#pt-ugc .vcard').forEach(function (card) {
    var v = card.querySelector('video');
    var p = card.querySelector('.vp');
    if (p) p.onclick = function () {
      $$('#pt-ugc video').forEach(function (o) { if (o !== v) { o.pause(); o.closest('.vcard').classList.remove('playing'); } });
      v.play(); card.classList.add('playing'); v.setAttribute('controls', '');
    };
    if (v) v.onpause = function () { card.classList.remove('playing'); };
  });
  (function () {
    var rail = $('#pt-ugc');
    if (!rail) return;
    var step = function () { var c = rail.querySelector('.vcard'); return c ? c.offsetWidth + 16 : 240; };
    var prev = $('#pt-ugcPrev'), next = $('#pt-ugcNext');
    if (next) next.onclick = function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); };
    if (prev) prev.onclick = function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); };
  })();

  // ---- update bundle row prices + all totals ----
  function updateBundleRows() {
    $$('#pt-bundle .brow').forEach(function (row) {
      var n = +row.dataset.n, disc = +row.dataset.disc;
      var per = priceFor(state.thickness, state.sizes[0]); // preview using board-1 size
      var full = per * n, net = Math.round(full * (1 - disc));
      var bp = row.querySelector('.bp'); if (bp) bp.textContent = fmt(net);
      var bc = row.querySelector('.bc'); if (bc) bc.textContent = disc > 0 ? fmt(full) : '';
    });
  }

  function update() {
    updateBundleRows();
    // Main price reflects the full selected board configuration (bundle net)
    var priceEl = $('#pt-price'); if (priceEl) priceEl.textContent = fmt(boardsTotal());
    // Cumulative July-rise saving across all boards in the selected bundle
    var sub = subtotal();
    var rrpEl = $('#pt-rrp'); if (rrpEl) rrpEl.textContent = fmt(sub * 2);
    var saveEl = $('#pt-save'); if (saveEl) saveEl.textContent = fmt(sub);
    // Equation: July-rise saving  +  bonus bundle saving  =  total savings
    var eqEl = $('#pt-promo-eq'), bonusAmt = $('#pt-bonus-amt'), totalAmt = $('#pt-total-amt');
    var bsave = Math.round(sub * state.disc);
    if (eqEl) {
      if (state.disc > 0 && bsave > 0) {
        eqEl.hidden = false;
        if (bonusAmt) bonusAmt.textContent = fmt(bsave);
        if (totalAmt) totalAmt.textContent = fmt(sub + bsave);
      } else {
        eqEl.hidden = true;
      }
    }
    var total = grandTotal();
    ['#pt-atctot', '#pt-atctot2', '#pt-stot'].forEach(function (sel) {
      var el = $(sel); if (el) el.textContent = fmt(total);
    });
    var segOn = root.querySelector('#pt-thick .seg.on');
    var thickLabel = segOn ? segOn.dataset.thickness : state.thickness;
    var setl = state.n === 1 ? 'Single board' : state.n + ' boards';
    var q = state.qty > 1 ? ' ×' + state.qty : '';
    var sum = $('#pt-ssummary'); if (sum) sum.textContent = setl + ' · ' + thickLabel + q;
    // Pro-upgrade trust badge — real Pro−Everyday delta, currency-dynamic
    var up = $('#pt-up-badge');
    if (up) {
      var d = priceFor(THICK_ORDER[1], state.sizes[0]) - priceFor(THICK_ORDER[0], state.sizes[0]);
      up.textContent = d > 0 ? '+' + fmtShort(d) : '';
    }
  }

  // ---- ADD TO CART (live AJAX) ----
  function buildItems() {
    var map = {}; // variantId -> qty
    for (var i = 0; i < state.n; i++) {
      var v = variantFor(state.thickness, state.sizes[i]);
      if (!v) continue;
      map[v.id] = (map[v.id] || 0) + 1;
    }
    var items = Object.keys(map).map(function (id) {
      return { id: Number(id), quantity: map[id] * state.qty };
    });
    if (state.sharp && DATA.sharpener && DATA.sharpener.id) {
      items.push({ id: Number(DATA.sharpener.id), quantity: state.qty });
    }
    return items;
  }

  function notifyDrawer(cart) {
    // Fire the common events third-party slide-out carts (Unicorn etc.) listen for.
    try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } })); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { cart: cart } })); } catch (e) {}
    try { window.dispatchEvent(new CustomEvent('cart:build')); } catch (e) {}
    try { document.body.dispatchEvent(new CustomEvent('product:added', { bubbles: true })); } catch (e) {}
    // Dawn / Shopify section bus
    if (window.Shopify && window.Shopify.designMode) {}
  }

  function doAdd(btn) {
    var items = buildItems();
    if (!items.length) return;
    var original = btn.innerHTML;
    btn.disabled = true; btn.classList.add('loading');
    btn.innerHTML = '<span>Adding…</span>';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart'); });
      return r.json();
    }).then(function () {
      return fetch('/cart.js').then(function (r) { return r.json(); });
    }).then(function (cart) {
      notifyDrawer(cart);
      btn.classList.remove('loading');
      btn.innerHTML = '<span>Added ✓</span>';
      setTimeout(function () { btn.disabled = false; btn.innerHTML = original; }, 1600);
      // No redirect — UpCart / third-party drawer listens to the events dispatched above.
    }).catch(function (err) {
      btn.classList.remove('loading');
      btn.innerHTML = '<span>' + (err.message || 'Try again') + '</span>';
      setTimeout(function () { btn.disabled = false; btn.innerHTML = original; }, 2200);
    });
  }
  ['#pt-atc', '#pt-atc2'].forEach(function (sel) {
    var b = $(sel); if (b) b.onclick = function () { doAdd(b); };
  });

  // ---- sticky ATC reveal ----
  var sticky = $('#pt-sticky'), buybox = $('#pt-buybox');
  if (sticky && buybox && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      sticky.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(buybox);
  }

  // ---- scroll reveal ----
  if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('in'); });
  }

  renderBoards();
  update();
})();

/* Thumbs carousel arrows + fade indicators */
(function(){
  var wraps = document.querySelectorAll('.pt-pdp .thumbs-wrap');
  wraps.forEach(function(w){
    var strip = w.querySelector('.thumbs');
    if(!strip) return;
    var prev = w.querySelector('.thumbs-nav.prev');
    var next = w.querySelector('.thumbs-nav.next');
    function update(){
      var maxScroll = strip.scrollWidth - strip.clientWidth - 1;
      w.setAttribute('data-can-prev', strip.scrollLeft > 4 ? '1' : '0');
      w.setAttribute('data-can-next', strip.scrollLeft < maxScroll ? '1' : '0');
      if(prev) prev.hidden = strip.scrollLeft <= 4;
      if(next) next.hidden = strip.scrollLeft >= maxScroll;
    }
    function step(dir){
      var t = strip.querySelector('.thumb');
      var w1 = t ? (t.getBoundingClientRect().width + 8) : 120;
      strip.scrollBy({ left: dir * w1 * 3, behavior: 'smooth' });
    }
    if(prev) prev.addEventListener('click', function(){ step(-1); });
    if(next) next.addEventListener('click', function(){ step(1); });
    strip.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    setTimeout(update, 50);
  });
})();

/* ---- July price-rise countdown ---- */
(function(){
  var wrap = document.getElementById('pt-promo');
  if(!wrap) return;
  var end = new Date(wrap.getAttribute('data-end')).getTime();
  var d=document.getElementById('pt-d'),h=document.getElementById('pt-h'),
      m=document.getElementById('pt-m'),s=document.getElementById('pt-s');
  function pad(n){return (n<10?'0':'')+n;}
  function tick(){
    var diff=end-Date.now();
    if(diff<=0){wrap.style.display='none';return;}
    var days=Math.floor(diff/86400000);
    var hrs=Math.floor(diff%86400000/3600000);
    var min=Math.floor(diff%3600000/60000);
    var sec=Math.floor(diff%60000/1000);
    if(d)d.textContent=pad(days);
    if(h)h.textContent=pad(hrs);
    if(m)m.textContent=pad(min);
    if(s)s.textContent=pad(sec);
  }
  tick(); setInterval(tick,1000);
})();
